import { withLazyLoading } from '@atlaskit/editor-common/lazy-node-view';
import { editorExperiment } from '@atlaskit/tmp-editor-statsig/experiments';
import { decisionItemNodeView } from './decisionItem';
export var lazyDecisionView = function lazyDecisionView(portalProviderAPI, eventDispatcher, api) {
  if (editorExperiment('platform_editor_exp_lazy_node_views', false)) {
    return decisionItemNodeView(portalProviderAPI, eventDispatcher, api);
  }
  return withLazyLoading({
    nodeName: 'decisionItem',
    getNodeViewOptions: function getNodeViewOptions() {},
    loader: function loader() {
      var result = import( /* webpackChunkName: "@atlaskit-internal_editor-plugin-tasks-and-decisions_decision-item-nodeview" */
      './decisionItem').then(function (_ref) {
        var decisionItemNodeView = _ref.decisionItemNodeView;
        return decisionItemNodeView(portalProviderAPI, eventDispatcher, api);
      });
      return result;
    }
  });
};